import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Products', to: '/products' },
  { label: 'Catalogue', to: '/catalogues' },
  { label: 'Contact', to: '/contact' }
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="navbar-wrapper">
      <nav className="navbar" aria-label="Primary navigation">
        <NavLink to="/" className="brand" onClick={closeMenu} aria-label="Zyvora Life Sciences 9 home">
          <img src="/assets/images/zyvora-cow-logo.png" alt="Zyvora Life Sciences 9 logo" className="brand-logo" />
          <span className="brand-wordmark"><strong>Zyvora</strong><small>Life Sciences&nbsp;9</small></span>
        </NavLink>

        <button type="button" className="mobile-toggle" aria-label="Toggle menu" aria-expanded={isOpen} onClick={() => setIsOpen((prev) => !prev)}>
          <span /><span /><span />
        </button>

        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMenu}>
                {item.label}
              </NavLink>
            </li>
          ))}
          <li><NavLink to="/contact" className="nav-cta" onClick={closeMenu}>Distributor Inquiry</NavLink></li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
